//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssociatedPart",1,0],[1,"Features",0,"Features.SelectFeatureList",0],[0,"HoleType",1,0],[0,"Owner",1,0],[0,"PlatingStyle",1,0],[0,"SpecifiedPart",1,0]],[],[]];
SPLM.PcbExchange.HoleAttributesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.HoleAttributesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.HoleAttributesBuilder.TypeEnum = Object.freeze({
    "Pin" : "Pin", "Via" : "Via", "Mounting" : "Mounting", "Tool" : "Tool", "Other" : "Other"});

SPLM.PcbExchange.HoleAttributesBuilder.PlatingStyleEnum = Object.freeze({
    "PlatedThru" : "PlatedThru", "NonPlatedThru" : "NonPlatedThru"});

SPLM.PcbExchange.HoleAttributesBuilder.AssociatedPartEnum = Object.freeze({
    "Board" : "Board", "Norefdes" : "Norefdes", "Specify" : "Specify"});

SPLM.PcbExchange.HoleAttributesBuilder.OwnerEnum = Object.freeze({
    "Mcad" : "Mcad", "Ecad" : "Ecad", "Unowned" : "Unowned"});

export default SPLM;